<script setup lang="ts">
import { ref } from "vue";
import router from "@/router";
import { pb } from "@/pocketbase"
import Button from '@/components/Button.vue';
import Input from '@/components/Input.vue';
import Heading from "@/components/Heading.vue";
import Error from "@/components/Error.vue";

const name = ref('');
const email = ref('');
const password = ref('');
const error = ref('');

async function signup() {
  try {
    error.value = '';
    await pb.collection('users').create({
      name: name.value,
      email: email.value,
      password: password.value,
      passwordConfirm: password.value,
    });
    await pb.collection('users').requestVerification(email.value);
    await pb.collection('users').authWithPassword(email.value, password.value);
    await router.push('/');
  } catch (e) {
    error.value = e.message;
  }
}
</script>

<template>
  <div class="space-y-2">
    <Heading>Sign Up</Heading>

    <form @submit.prevent="signup">
      <div class="shadow-sm">
        <Input v-model="name" id="name" name="name" label="Name" placeholder="Adam Savage"/>
        <Input v-model="email" id="email" name="email" label="Email" placeholder="you@example.com"/>
        <Input v-model="password" type="password" id="password" name="password" label="Password" placeholder="secret_password"/>
      </div>
      <div>
        <Button label="Sign Up" icon="add-user"></Button>
      </div>
    </form>

    <Error v-if="error">
      {{ error }}
    </Error>
  </div>
</template>

<style scoped lang="scss">
</style>
